import { useIntl } from "react-intl";
import { getFixedColumns, getScrollableColumns } from "./tableConfigs";
import { renderTableCaption, renderTableHead } from "../../../../utils/tableUtils";

import "../styles.scss";

const SkeletonTable = (props: { onlyRows?: boolean | undefined }) => {
  const intl = useIntl();
  const fixedColumns = getFixedColumns(intl);
  const scrollableColumns = getScrollableColumns(intl);
  
  return (
    <div id="TableCommonDemo">
      <div className="tables-row" style={{ gap: 0, justifyContent: 'flex-start' }}>
        <div className="skeleton-tables-row__fixed min-w-[800px]">
          <table
            className="table table-layout-fixed table-bordered"
          >
            <colgroup>{fixedColumns.map((column) => renderTableCaption(column.value, column.details))}</colgroup>
            {!props.onlyRows && (
              <thead>
                <tr>{fixedColumns.map((column) => renderTableHead(column.value, column.label, "vehicle", () => {}))}</tr>
              </thead>
            )}
            <tbody>
              {new Array(50).fill(0).map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {fixedColumns.map((column, colIndex) => (
                    <td
                      key={`${column}-${rowIndex}-${colIndex}`}
                      data-field={column.label}
                      style={column.value !== "veiculo" ? {whiteSpace: 'nowrap'} : {}}
                      className="animate-pulse"
                    >
                      <div className="w-3/4 h-4 bg-gray-300 rounded" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="skeleton-scrollabe-table">
          <table className="table table-layout-fixed table-column-overflow-hidden table-bordered table-head-filled"  style={{ minWidth: '1650px' }}>
            <colgroup>
              {scrollableColumns.map((column) => renderTableCaption(column.value, column.details))}
            </colgroup>
            {!props.onlyRows && (
              <thead>
                <tr>{scrollableColumns.map((column) => renderTableHead(column.value, column.label, "vehicle", () => {}))}</tr>
              </thead>
            )}
            <tbody>
              {new Array(50).fill(0).map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {scrollableColumns.map((colum) => (
                    <td key={colum.value} className="animate-pulse">
                      <div className="w-3/4 h-4 bg-gray-300 rounded" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SkeletonTable;
